import { Link } from 'react-router-dom';

function toggleMenu() {
  let body = document.querySelector('body');
  let hamburgerMenu = document.querySelector('.hamburger-menu');
  let navMenu = document.querySelector('.site-header nav');
  body.classList.toggle('fixed');
  hamburgerMenu.classList.toggle('active');
  navMenu.classList.toggle('open');
  window.scrollTo(0, 0);
}

function Menu() {

  return (
    <ul>
      <li><Link to='/nos-ap' onClick={toggleMenu}>Nos accès <br/> précoces (AP)</Link></li>
      <li><Link to='/nos-ac' onClick={toggleMenu}>Nos accès <br/> compassionnels (AC)</Link></li>
      <li><Link to='/nos-cpc' onClick={toggleMenu}>Nos cadres de prescription <br/> compassionnelle (CPC)</Link></li>
      <li><Link to='/nos-rusd' onClick={toggleMenu}>Nos recherches avec utilisation <br/> secondaire des données (RUSD)</Link></li>
    </ul>
  )
}

export default Menu